import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * LinkedIn Insight Tag loader — Partner ID 9659426.
 * Fires only when `consent === true` (marketing/analytics cookies accepted).
 * The tag is inserted globally exactly once, before </body> (via a ref to
 * document.body). The <noscript> fallback pixel is added the same way.
 * Also fires a page view on every SPA route change so client-side
 * navigations are attributed correctly.
 * Do NOT alter the tag code or Partner ID.
 */
export const LinkedInInsight = ({ consent }) => {
  const location = useLocation();

  // Base tag install — runs once when consent is granted.
  useEffect(() => {
    if (!consent) return;
    if (window.__vemoye_li_loaded) return;
    window.__vemoye_li_loaded = true;

    // Config script
    const cfg = document.createElement("script");
    cfg.type = "text/javascript";
    cfg.dataset.vemoyeLi = "config";
    cfg.text = `
      _linkedin_partner_id = "9659426";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
    `;
    document.body.appendChild(cfg);

    // Loader script (LinkedIn's exact recommended snippet)
    const loader = document.createElement("script");
    loader.type = "text/javascript";
    loader.dataset.vemoyeLi = "loader";
    loader.text = `
      (function(l) {
        if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
        window.lintrk.q=[]}
        var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);})(window.lintrk);
    `;
    document.body.appendChild(loader);

    // noscript pixel fallback
    const ns = document.createElement("noscript");
    ns.dataset.vemoyeLi = "noscript";
    ns.innerHTML = `<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=9659426&fmt=gif" />`;
    document.body.appendChild(ns);
  }, [consent]);

  // SPA route-change page tracking — dedupe by pathname so remounts and
  // StrictMode double-invocations do not fire duplicate tracks.
  useEffect(() => {
    if (!consent) return;
    if (typeof window.lintrk !== "function") return;
    if (!window.__vemoye_li_first_view_sent) {
      window.__vemoye_li_first_view_sent = true;
      window.__vemoye_li_last_view_path = location.pathname;
      return;
    }
    if (window.__vemoye_li_last_view_path === location.pathname) return;
    window.__vemoye_li_last_view_path = location.pathname;
    try { window.lintrk("track"); } catch {}
  }, [location.pathname, consent]);

  return null;
};

export default LinkedInInsight;
